import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface FinFlags {
  paymolo_enabled: boolean;
  paygo_enabled: boolean;
}

/** Charge les drapeaux d'éligibilité financement (Pay Molo / PayGo) par produit. */
export function useProductFinancing() {
  const [map, setMap] = useState<Record<string, FinFlags>>({});
  useEffect(() => {
    if (!supabase) return;
    supabase
      .from('product_financing')
      .select('product_slug, paymolo_enabled, paygo_enabled')
      .eq('is_active', true)
      .then(({ data }) => {
        if (!data) return;
        const m: Record<string, FinFlags> = {};
        for (const r of data as { product_slug: string; paymolo_enabled: boolean; paygo_enabled: boolean }[]) {
          m[r.product_slug] = { paymolo_enabled: r.paymolo_enabled, paygo_enabled: r.paygo_enabled };
        }
        setMap(m);
      });
  }, []);
  return map;
}
